const TOKEN_KEY     = 'wfm_token'
const USER_CODE_KEY = 'wfm_user_code'
const USER_NAME_KEY = 'wfm_user_name'
const USER_TYPE_KEY = 'wfm_user_type'

export interface AuthState {
  token:    string
  userCode: number
  userName: string
  userType: number
}

export function loadAuth(): AuthState | null {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return null
  return {
    token,
    userCode: Number(localStorage.getItem(USER_CODE_KEY) ?? '0'),
    userName: localStorage.getItem(USER_NAME_KEY) ?? '',
    userType: Number(localStorage.getItem(USER_TYPE_KEY) ?? '0'),
  }
}

export function saveAuth(a: AuthState): void {
  localStorage.setItem(TOKEN_KEY,     a.token)
  localStorage.setItem(USER_CODE_KEY, String(a.userCode))
  localStorage.setItem(USER_NAME_KEY, a.userName)
  localStorage.setItem(USER_TYPE_KEY, String(a.userType))
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_CODE_KEY)
  localStorage.removeItem(USER_NAME_KEY)
  localStorage.removeItem(USER_TYPE_KEY)
}

// 로그인 응답 ResultData 파싱: token \x18 user_code \x18 user_name \x18 user_type
export function parseLoginData(data: string): AuthState | null {
  if (!data) return null
  const parts = data.split('\x18')
  if (parts.length < 4) return null
  return {
    token:    parts[0],
    userCode: Number(parts[1]) || 0,
    userName: parts[2],
    userType: Number(parts[3]) || 0,
  }
}
